import type { SettlementRepository } from '../repository/SettlementRepository';
import type {
  ProjectMonthlySumSearchRequest,
  ProjectMonthlySumSearchResponse,
} from '../entity/SettlementTypes';

/**
 * 프로젝트 월별 후원 합계 검색 (POST /projectmonthlysum/m/sch)
 */
export class SearchProjectMonthlySumUseCase {
  constructor(private readonly repository: SettlementRepository) {}

  execute(request: ProjectMonthlySumSearchRequest): Promise<ProjectMonthlySumSearchResponse> {
    return this.repository.searchProjectMonthlySum(request);
  }
}
